module.exports = __webpack_public_path__ + "img/new_index_cases25.3391b7ad.png";